module.exports = __webpack_public_path__ + "media/img/logos/brand-2158f579d04c377cec07a21e44c29f7f.svg";